import { useTranslation } from 'react-i18next'

export function NoAccessScreen({ onSignOut }: { onSignOut: () => void }) {
  const { t } = useTranslation()
  return (
    <main className="asf-centered">
      <h1>{t('no_access_title')}</h1>
      <p>{t('no_access_body')}</p>
      <button type="button" onClick={onSignOut}>
        {t('sign_out')}
      </button>
    </main>
  )
}
